import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    package_tab_container: {
        width: '100%',
    },
}));

export {useStyles}